import HistoryControl from '../../controls/product/HistoryControl';

function HistorySection(props) {
  return <HistoryControl />;
}

export default HistorySection;
